import { render } from "./CourseFinder.vue?vue&type=template&id=34c3a902&scoped=true"
import script from "./CourseFinder.vue?vue&type=script&lang=js"
export * from "./CourseFinder.vue?vue&type=script&lang=js"

import "./CourseFinder.vue?vue&type=style&index=0&id=34c3a902&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c3a902"]])

export default __exports__